import { addQuotes } from '../utils/smartutils';

export function courseListByFilter(filter) {
  const query = `{courseListByFilter(filter:  ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) 
  {
    id
    name
    createdAt
    coordinator {
      name
    }
    steps { id fullName }
  }
}`;
  return query;
}

export function courseListById(filter) {
  const query = `{courseListByFilter(filter:  ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) 
  {
    id
    name
    minFrequency
    mediaApproval
    durationInDays
    workload
    minNote
    maxNote
    coordinator {
      id
      name
    }
    director {
      id
      name
    }
    steps {
      id
      fullName
      duration
      cycleQuantity
    }
     curriculum {
        id
        subject {
          id 
          name
        }
        step { 
          id 
          fullName
          cycleQuantity
        }
        stepWorkLoad
     }
     objectives {
        id
        specific
        general
        subject {
            id 
            name
        }
     }
  }
}`;
  return query;
}

export function saveCourseMutation(values) {
  const name = addQuotes(values.name);
  let { curriculum } = values;
  if (curriculum && curriculum.length) {
    curriculum = curriculum.map((value) => ({
      id: value.id,
      step: {
        id: value.step.id,
        cycleQuantity: value.step.cycleQuantity,
      },
      subject: {
        id: value.subject.id,
        termFilterId: 0,
        filterByStatus: false,
        updaterId: 0,
        subjectLevelFilterId: 0,
        active: true,
      },
      stepWorkLoad: value.stepWorkLoad,
    }));
  }
  if (values.curriculumGrouped && values.curriculumGrouped.length) {
    const { curriculumGrouped } = values;
    const curriculumWithoutFormatting = curriculumGrouped.reduce(
      (arr, value) => arr.concat(value),
      []
    );
    curriculum = curriculumWithoutFormatting.map((value) => ({
      id: value.id,
      step: {
        id: value.step.id,
        cycleQuantity: value.step.cycleQuantity,
      },
      subject: {
        id: value.subject.id,
        termFilterId: 0,
        filterByStatus: false,
        updaterId: 0,
        subjectLevelFilterId: 0,
        active: true,
      },
      stepWorkLoad: value.stepWorkLoad,
    }));
  }

  let objectivesFormatted = [];
  if (values.objectives && values.objectives.length) {
    const { objectives } = values;
    objectivesFormatted = objectives.map((objective) => ({
      id: objective.id || 0,
      subject: {
        id: objective.subject.id,
        termFilterId: 0,
        filterByStatus: false,
        updaterId: 0,
        subjectLevelFilterId: 0,
        active: true,
      },
      general: objective.general,
      specific: objective.specific,
    }));
  }
  let director = '';
  if (values.director) {
    director = `director: {
      id: ${values.director.id}
      usuarioChatInterno: false
      ativo: true
      filterByStatus: false
      pedagogicAdm: false
      updaterId: 0
      active: true
      usuarioChat: false
    }`;
  }
  const mutationQuery = `mutation {
    courseSave(
      course: {
        id: ${values.id || 0}
        name: ${name}
        coordinator: {
          id: ${values.coordinator.id}
          usuarioChatInterno: false
          ativo: true
          filterByStatus: false
          pedagogicAdm: false
          updaterId: 0
          active: true
          usuarioChat: false
        }
        ${director}
        steps: ${JSON.stringify(values.steps).replace(/"([^(")"]+)":/g, '$1:')}
        minFrequency: ${parseFloat(values.minFrequency)}
        mediaApproval: ${parseFloat(values.mediaApproval)}
        durationInDays: ${parseInt(values.durationInDays, 10) || null}
        workload: ${parseFloat(values.workload) || null}
        minNote: ${parseFloat(values.minNote)}
        maxNote: ${parseFloat(values.maxNote)}
        useGridSchedule: false
        active: ${values.active || true}
        excluded: ${values.excluded || false}
        filterByStatus: false
        updaterId: 0
        curriculum: ${JSON.stringify(curriculum).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}
        objectives: ${JSON.stringify(objectivesFormatted).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}
      }
    ) {
    id
    }
}
`;
  return mutationQuery;
}

export function removeCourse(id) {
  return `mutation {courseRemove(id: ${id})}`;
}

export function courseListForSchoolClass(filter) {
  const query = `{courseListByFilter(filter:  ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) 
  {
    id
    name
    steps { id fullName, cycleQuantity }
    curriculum {
        id
        subject {
          id 
          name
        }
        step { 
          id 
          fullName
          cycleQuantity
        }
        stepWorkLoad
     }
  }
}`;
  return query;
}

export function courseStepRemoveById(stepId) {
  return `mutation { courseStepRemoveById(stepId: ${stepId}) }`;
}

export default function listCoursesWithStepsByFilter(filter) {
  return `{
  courseListByFilter(filter: ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) {
    id
    name
    label
    value
    steps {
      id
      fullName
      label
      value
      cycleQuantity
    }
  }
}
`;
}
